import type { InlineInputProps, InlineInputValueProps } from './index.type';
import InlineInputBase from './InlineInput';

export default InlineInputBase;

export type { InlineInputProps, InlineInputValueProps };
